/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Notification } from '../models/Notification';
import type { NotificationFilter } from '../models/NotificationFilter';
import type { NotificationsList } from '../models/NotificationsList';
import { request as __request } from '../core/request';

export class NotificationsService {

    /**
     * @param requestBody
     * @returns NotificationsList Ok
     * @throws ApiError
     */
    public static async getNotificationsList(
        requestBody?: NotificationFilter,
    ): Promise<NotificationsList> {
        const result = await __request({
            method: 'POST',
            path: `/notifications/list`,
            body: requestBody,
            errors: {
                400: `Validation Failed`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param notifId
     * @returns Notification Ok
     * @throws ApiError
     */
    public static async getNotificationById(
        notifId: number,
    ): Promise<Notification> {
        const result = await __request({
            method: 'POST',
            path: `/notifications/detail/${notifId}`,
            errors: {
                400: `Validation Failed`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @returns string Ok
     * @throws ApiError
     */
    public static async notificationsCheck(): Promise<string> {
        const result = await __request({
            method: 'GET',
            path: `/notifications/check`,
            errors: {
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

}